import { patchState, signalStore, withMethods, withState } from '@ngrx/signals';

const storageKey = 'docs-theme-storage-current-name';

interface AppState {
  theme: string;
}

const initialState: AppState = {
  theme: 'dark',
};

export const ApplicationStore = signalStore(
  withState(() => {
    const theme = window.localStorage[storageKey] || null;
    if (theme) {
      initialState.theme = theme;
    }
    return initialState
  }),

  withMethods((store) => ({

    setTheme(theme: string) {
      patchState(store, () => ({
        theme
      }))
      window.localStorage[storageKey] = theme;
    }

  }))
);
